import { frontendURL } from '../../../helper/URLHelper';
import SchedulingDashboard from './pages/SchedulingDashboard.vue';
import PublicBookingPage from './pages/PublicBookingPage.vue';
import ProfessionalPortalPage from './pages/ProfessionalPortalPage.vue';

const commonMeta = {
  featureFlag: 'scheduling_appointments',
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/scheduling'),
    name: 'scheduling_dashboard_index',
    component: SchedulingDashboard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/scheduling/:tab'),
    name: 'scheduling_dashboard_tab',
    component: SchedulingDashboard,
    meta: commonMeta,
  },
  {
    path: '/schedule/:slug_or_id',
    name: 'public_scheduling_booking',
    component: PublicBookingPage,
    meta: {
      public: true,
    },
  },
  {
    path: '/schedule',
    name: 'public_scheduling_root',
    component: PublicBookingPage,
    meta: {
      public: true,
    },
  },
  {
    path: '/portal/profissional',
    name: 'professional_portal_page',
    component: ProfessionalPortalPage,
    meta: {
      public: true,
    },
  },
  {
    path: '/portal',
    name: 'professional_portal_root',
    component: ProfessionalPortalPage,
    meta: {
      public: true,
    },
  },
];
